"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HooksService = void 0;
const tools_1 = require("@shoppykey/tools");
require("reflect-metadata");
const hookAction_decorator_1 = require("./hookAction.decorator");
const utils_1 = require("./utils");
class HooksService {
    handlers = new Map();
    context = {};
    setContext(_context) {
        Object.assign(this.context, _context);
    }
    getContext() {
        return this.context;
    }
    registerHookActions(hookAction) {
        (0, utils_1.scanProviderPropertyMetaDates)(hookAction, hookAction_decorator_1.HOOK_ACTION_METADATA, (propertyKey, metadata) => {
            this.registerHookAction(hookAction, propertyKey, metadata);
        });
    }
    removeHookActions(hookAction) {
        (0, utils_1.scanProviderPropertyMetaDates)(hookAction, hookAction_decorator_1.HOOK_ACTION_METADATA, (propertyKey, metadata) => {
            this.removeHookAction(hookAction, propertyKey, metadata);
        });
    }
    registerHookAction(hookAction, methodName, hook) {
        const matchInfo = {
            methodName,
            hookAction,
            options: { ...hook.options },
        };
        this.setHandlers(hook.hookName, matchInfo);
    }
    removeHookActionByKey(hookName, key) {
        let existingHandlers = this.handlers.get(hookName) || [];
        if (key) {
            existingHandlers = existingHandlers.filter((action) => {
                const existingHandler = action.options?.key !== key;
                if (!existingHandler) {
                    tools_1.logs.warn(`removing action by ${hookName}:${key} ${action.hookAction.constructor.name}:${action.methodName}`);
                }
                return existingHandler;
            });
        }
        this.handlers.set(hookName, existingHandlers);
    }
    setHandlers(hookName, matchInfo) {
        if (matchInfo.options?.key) {
            this.removeHookActionByKey(hookName, matchInfo.options.key);
        }
        let existingHandlers = this.handlers.get(hookName) || [];
        this.handlers.set(hookName, [...existingHandlers, matchInfo]);
    }
    removeHookAction(hookAction, methodName, hook) {
        const existingHandlers = this.handlers.get(hook.hookName) || [];
        this.handlers.set(hook.hookName, existingHandlers.filter((existingHandler) => {
            return !(existingHandler.hookAction.constructor === hookAction.constructor && existingHandler.methodName === methodName);
        }));
    }
    async runHook(hookName, context) {
        const actions = this.findActions(hookName);
        return this.callActions(actions, { hookName, ...context });
    }
    runHookSync(hookName, context) {
        const actions = this.findActions(hookName);
        return this.callActionsSync(actions, { hookName, ...context });
    }
    async callActions(actions, context) {
        return actions
            ?.sort((a, b) => (a.options?.sort || 0) - (b.options?.sort || 0))
            ?.reduce(async (res, action) => {
            const result = await res;
            const resultItem = await this.callAction(action, context);
            return [...result, resultItem];
        }, Promise.resolve([]));
    }
    callActionsSync(actions, context) {
        return actions
            ?.sort((a, b) => (a.options?.sort || 0) - (b.options?.sort || 0))
            ?.map((action) => {
            return this.callActionSync(action, context);
        });
    }
    async callAction(action, _context) {
        const context = {
            ...this.context,
            ..._context,
            ...action.options?.context,
        };
        const params = (0, hookAction_decorator_1.findHookActionParams)(action.hookAction, action.methodName);
        const callParams = params.map((param, index) => {
            if (!param.name)
                return context;
            const value = (0, tools_1.get)(context, param.name);
            if ((value === null || value === undefined) && param.required !== false) {
                throw new Error(`${action.methodName} param error ${index} ${param.name}`);
            }
            return value;
        });
        const result = await action.hookAction[action.methodName].call(action.hookAction, ...callParams);
        return result;
    }
    callActionSync(action, _context) {
        const context = {
            ...this.context,
            ..._context,
            ...action.options?.context,
        };
        const params = (0, hookAction_decorator_1.findHookActionParams)(action.hookAction, action.methodName);
        const callParams = params.map((param, index) => {
            if (!param.name)
                return context;
            const value = (0, tools_1.get)(context, param.name);
            if ((value === null || value === undefined) && param.required !== false) {
                throw new Error(`${action.methodName} param error ${index} ${param.name}`);
            }
            return value;
        });
        const result = action.hookAction[action.methodName].call(action.hookAction, ...callParams);
        return result;
    }
    findActions(hookName) {
        const actions = this.handlers.get(hookName) || [];
        return actions;
    }
    findActionByKey(hookName, key) {
        const actions = this.handlers.get(hookName) || [];
        return actions.find((action) => action.options?.key === key);
    }
    hasActionByKey(hookName, key) {
        const action = this.findActionByKey(hookName, key);
        return !!action;
    }
    async runHookByKey(hookName, key, context) {
        const action = this.findActionByKey(hookName, key);
        if (!action) {
            return;
        }
        return this.callAction(action, context);
    }
    async runHookByKeyOrFail(hookName, key, context) {
        const action = this.findActionByKey(hookName, key);
        if (!action) {
            throw new Error(`not found ${hookName} ${key} action`);
        }
        return this.callAction(action, context);
    }
    runHookByKeySync(hookName, key, context) {
        const action = this.findActionByKey(hookName, key);
        if (!action) {
            return;
        }
        return this.callActionSync(action, context);
    }
    runHookByKeyOrFailSync(hookName, key, context) {
        const action = this.findActionByKey(hookName, key);
        if (!action) {
            throw new Error(`not found ${hookName} ${key} action`);
        }
        return this.callActionSync(action, context);
    }
}
exports.HooksService = HooksService;
//# sourceMappingURL=hooksService.js.map